import * as bc from "bc-js";

import { GabaritNavigationUtil } from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import { LangueUtils } from "@oel/js-i18n";
import { en } from "./i18n/DetailsMargeCredit.i18n.en";
import { fr } from "./i18n/DetailsMargeCredit.i18n.fr";
import { useParams } from 'react-router';
import { useEffect } from "react";
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function DetailsMargeCredit() {

    const params = useParams();
    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = libelles.titreOnglet;
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.DETAIL_MARGE_CREDIT_ADP);
        
        bc.changerContexte("ACCOUNT_Detail");

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <detail-marge-credit id-contexte={params.idContexte} />
        </div>
    );
}
